<template>
    <div class="p-t-xs-20 p-b-xs-20">

        <div v-if="order && cart && receipt" class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="m-b-xs-20">
                        <ak-button
                            size="small"
                            @click="backToOrders"
                        >
                            <i class="ak-icon ak-button__icon">arrow_left</i>
                            {{ $t('Ga terug') }}
                        </ak-button>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Opmerkingen') }}
                            </div>
                            <a class="m-l-auto" href="#" @click.prevent="openCommentsForm">
                                <i class="fa fa-lg fa-plus-square-o"></i> {{ $t('Opmerking toevoegen') }}
                            </a>
                        </div>
                        <div
                            class="ak-panel__body ak-panel__body--small reading"
                            :class="{'muted': !order.comments}"
                        >
                            {{ order.comments ? order.comments : $t('Geen opmerkingen') }}
                        </div>
                    </div>
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Bestelling')}}
                            </div>
                            <strong class="m-l-auto">{{cart.code}}</strong>
                        </div>
                        <table class="ak-table ak-table--compact ak-panel__table">
                            <thead>
                                <tr class="ak-table-row">
                                    <th class="ak-table-head">
                                        {{ $t('Artikel') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Aantal') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Prijs') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="ak-table-body">
                                <tr v-for="line in receipt.items" class="ak-table-row">
                                    <td class="ak-table-column">
                                        <a v-if="line.shoppable.href" :href="line.shoppable.href" class="ak-link ak-link--uppercase" target="_blank" v-html="line.title">

                                        </a>
                                        <span v-else v-html="line.title">

                                        </span>
                                    </td>
                                    <td class="ak-table-column">
                                        {{ line.quantity }}
                                        <template v-if="getPartialCancellationLine(line)">
                                            <br>
                                            <small class="text-muted">
                                                {{ $t('Gedeeltelijk geannuleerd: van @from naar @to', {
                                                    '@from': getPartialCancellationLine(line).originalQuantity,
                                                    '@to': getPartialCancellationLine(line).newQuantity
                                                }) }}
                                            </small>
                                        </template>
                                    </td>
                                    <td class="ak-table-column">{{line.amount.formatted}}</td>
                                </tr>
                                <tr v-for="line in receipt.lines" class="ak-table-row">
                                    <td class="ak-table-column"></td>
                                    <td class="ak-table-column text--right" v-html="line.title"></td>
                                    <td class="ak-table-column">{{line.amount.formatted}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Verzending') }}
                            </div>
                        </div>
                        <table class="ak-table ak-table--compact ak-panel__table">
                            <thead>
                                <tr class="ak-table-row">
                                    <th class="ak-table-head">
                                        {{ $t('Artikel') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Methode') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Adres') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Status') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="ak-table-body">
                                <tr v-for="item in inspector.items" class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ item.title }}
                                    </td>
                                    <td class="ak-table-column">
                                        {{ item.shippingTypeAsString }}
                                    </td>
                                    <td class="ak-table-column">
                                        <template v-if="item.shippingTypeLocation">
                                            {{ item.shippingTypeLocation.name ? item.shippingTypeLocation.name : item.shippingTypeLocation.full }}
                                        </template>
                                    </td>
                                    <td class="ak-table-column">
                                        <template v-if="item.pickup && item.shippingType === 2">
                                            <a
                                                v-if="!item.pickup.dateDelivered"
                                                href="#"
                                                @click.prevent="openPickupForm(item)"
                                            >
                                                <i class="fa fa-lg fa-arrow-right"></i> {{ $t('Markeren als geleverd bij afhaalpunt') }}
                                            </a>
                                            <a
                                                v-else
                                                href="#"
                                                style="color:green;"
                                                @click.prevent="openPickupForm(item)"
                                            >
                                                <i class="fa fa-lg fa-arrow-right"></i> {{ $t('Geleverd bij het afhaalpunt') }}
                                            </a>
                                        </template>
                                        <template v-else-if="item.delivery && [3,4].includes(item.shippingType)">
                                            <a
                                                v-if="!item.delivery.dateDelivered"
                                                href="#"
                                                @click.prevent="openDeliveryForm(item)"
                                            >
                                                <i class="fa fa-lg fa-arrow-right"></i> {{ $t('Markeren als verzonden') }}
                                            </a>
                                            <a
                                                v-else
                                                href="#"
                                                style="color:green;"
                                                @click.prevent="openDeliveryForm(item)"
                                            >
                                                <i class="fa fa-lg fa-check"></i> {{ $t('Verzonden') }}
                                            </a>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="digitalItems.length && order.isPaid" class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Digitale tickets') }}
                            </div>
                        </div>
                        <table class="ak-table ak-table--compact ak-panel__table">
                            <tbody>
                                <tr
                                    v-for="item in digitalItems"
                                    :key="item.id"
                                    class="ak-table-row"
                                >
                                    <td class="ak-table-column">{{ item.title }}</td>
                                    <td class="ak-table-column">
                                        <a :href="`:/download/cart-pdf/${item.hashId}`">
                                            {{ $t('Download PDF') }}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="cartItemsPickup.length && order.isPaid" class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Afhaling') }}
                            </div>
                        </div>
                        <table class="ak-table ak-table--compact ak-panel__table">
                            <thead>
                                <tr class="ak-table-row">
                                    <th class="ak-table-head">
                                        {{ $t('Artikel') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Afhaalpunt') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Status') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="ak-table-body">
                                <tr v-for="item in cartItemsPickup" class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ item.title }}
                                    </td>
                                    <td class="ak-table-column">
                                        {{ item.pickup.locationTitle }} <br />
                                        <span class="text-muted">
                                            {{ item.pickup.locationStreet }}
                                            {{ item.pickup.locationStreetNumber }}
                                            {{ item.pickup.locationPostalCode }}
                                            {{ item.pickup.locationCity }}
                                        </span>
                                    </td>
                                    <td class="ak-table-column">
                                        <a
                                            v-if="!item.pickup.dateDelivered"
                                            href="#"
                                            @click.prevent="openPickupForm(item)"
                                        >
                                            <i class="fa fa-lg fa-arrow-right"></i> {{ $t('Markeren als geleverd bij afhaalpunt') }}
                                        </a>
                                        <a
                                            v-else
                                            href="#"
                                            style="color:green;"
                                            @click.prevent="openPickupForm(item)"
                                        >
                                            <i class="fa fa-lg fa-check"></i> {{ $t('Geleverd bij het afhaalpunt') }}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div
                        v-if="dellOrder"
                        class="ak-panel ak-panel--no-padding m-b-xs-20"
                    >
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Dell bestelling') }} - {{ $t('referentie') }} <strong>{{ dellOrder.code }}</strong>
                            </div>
                        </div>
                        <table class="ak-table ak-table--compact ak-panel__table">
                            <tbody class="ak-table-body">
                            <tr
                                v-for="item in dellOrder.items"
                                :key="item.id"
                                class="ak-table-row"
                            >
                                <td class="ak-table-column">{{ item.supplierPartAuxiliaryId }}</td>
                                <td class="ak-table-column">{{ item.quantity }}</td>
                                <td class="ak-table-column">{{ item.description }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div
                        v-if="hpOrder"
                        class="ak-panel ak-panel--no-padding m-b-xs-20"
                    >
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('HP bestelling') }} - {{ $t('referentie') }} <strong>{{ hpOrder.code }}</strong>
                            </div>
                        </div>
                        <table class="ak-table ak-table--compact ak-panel__table">
                            <tbody class="ak-table-body">
                                <tr
                                    v-for="item in hpOrder.items"
                                    :key="item.id"
                                    class="ak-table-row"
                                >
                                    <td class="ak-table-column">{{ item.supplierPartAuxiliaryId }}</td>
                                    <td class="ak-table-column">{{ item.quantity }}</td>
                                    <td class="ak-table-column">{{ item.description }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div
                        v-for="catalogueOrder in catalogueOrders"
                        :key="catalogueOrder.id"
                        class="ak-panel ak-panel--no-padding m-b-xs-20"
                    >
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ catalogueOrder.catalogue ? catalogueOrder.catalogue.title : $('Catalogus') }} {{ $t('bestelling') }} - {{ $t('referentie') }}  <strong>{{ catalogueOrder.code }}</strong>
                            </div>
                        </div>
                        <table class="ak-table ak-table--compact ak-panel__table">
                            <tbody class="ak-table-body">
                                <tr
                                    v-for="item in catalogueOrder.items"
                                    :key="item.id"
                                    class="ak-table-row"
                                >
                                    <td class="ak-table-column">{{ item.articleCode }}</td>
                                    <td class="ak-table-column">{{ item.quantity }}</td>
                                    <td class="ak-table-column">{{ item.description }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Historiek')}}
                            </div>
                        </div>
                        <table class="ak-table ak-table--compact ak-panel__table">
                            <thead>
                                <tr class="ak-table-row">
                                    <th class="ak-table-head">
                                        {{ $t('Datum') }}
                                    </th>
                                    <th class="ak-table-head">
                                        {{ $t('Gebeurtenis') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="ak-table-body">
                                <tr v-if="order.dateCancelled" class="ak-table-row">
                                  <td class="ak-table-column">{{order.dateCancelled | datetime }}</td>
                                  <td class="ak-table-column">
                                    {{ $t('Bestelling geannuleerd') }}
                                  </td>
                                </tr>
                                <tr v-if="order.dateOfShipping" class="ak-table-row">
                                  <td class="ak-table-column">{{order.dateOfShipping | datetime }}</td>
                                  <td class="ak-table-column">
                                    {{ $t('Bestelling verzonden') }}
                                  </td>
                                </tr>
                                <tr v-if="order.paymentStatus === 1 && order.dateOfPayment" class="ak-table-row">
                                  <td class="ak-table-column">{{order.dateOfPayment | datetime }}</td>
                                  <td class="ak-table-column">
                                    {{ $t('Betaling ontvangen via @type', {'@type': inspector.paymentType.title}) }}
                                  </td>
                                </tr>
                                <tr
                                    v-for="line in partialCancellationLinesSorted"
                                    :key="`partial-cancel-${line.id}`"
                                    class="ak-table-row"
                                >
                                    <td class="ak-table-column">{{ (line.createdAt || line.updatedAt) | datetime }}</td>
                                    <td class="ak-table-column">
                                        {{ $t('Gedeeltelijke annulatie: @product (van @from naar @to)', {
                                            '@product': getProductTitleById(line.productId),
                                            '@from': line.originalQuantity,
                                            '@to': line.newQuantity
                                        }) }}
                                    </td>
                                </tr>
                                <tr v-if="inspector.isOrdered" class="ak-table-row">
                                    <td class="ak-table-column">{{order.date | datetime }}</td>
                                    <td class="ak-table-column">
                                        {{ $t('Bestelling geplaatst') }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">{{cart.date | datetime }}</td>
                                    <td class="ak-table-column">{{ $t('Creatie winkelmandje')}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <template v-if="inspector.isOrdered">
                        <ak-button
                            size="small"
                            @click="openShippingForm"
                        >
                            {{ $t('Verzending') }}
                        </ak-button>

                        <ak-button
                            v-if="order && ! order.isPaid && ! order.cancelled"
                            size="small"
                            :disabled="exactOrderPartial"
                            @click="openPartialCancelForm"
                        >
                            {{ $t('Bestelling gedeeltelijk annuleren') }}
                        </ak-button>

                        <ak-button
                            v-if="order && ! order.isPaid && ! order.cancelled"
                            size="small"
                            @click="cancelOrder"
                            :enableConfirm="true"
                            :confirmTitle="$t('Ben je zeker?')"
                            :confirmText="$t('Ben je zeker dat je deze bestelling wil annuleren?')"
                        >
                            {{ $t('Bestelling volledig annuleren') }}
                        </ak-button>
                    </template>

                </div>
                <div class="col-lg-4">
                    <div class="ak-panel m-b-xs-20  ak-panel--no-padding">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Betaling')}}
                            </div>
                            <a href="#" class="m-l-auto" @click.prevent="markAsPaid">
                                <i class="fa fa-check"></i>
                            </a>
                        </div>
                        <table v-if="order.paymentStatus === 1" class="ak-table ak-table--compact ak-panel__table">
                            <tbody class="ak-table-body">
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ $t('Betaling ontvangen')}}
                                    </td>
                                </tr>
                                <tr v-if="ogm" class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ ogm.ogm }}
                                    </td>
                                </tr>
                                <tr v-if="inspector.paymentType" class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ inspector.paymentType.title }}
                                    </td>
                                </tr>
                                <tr v-if="order.paymentCardHolderName" class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ order.paymentCardHolderName }}
                                    </td>
                                </tr>
                                <tr v-if="order.getPaymentCardNumber" class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ order.getPaymentCardNumber }}
                                        <div v-if="order.paymentCardExpirationMonthAndYear">
                                            {{ $t('Vervaldatum') }} {{ order.paymentCardExpirationMonthAndYear}}
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="order.paymentMessage" class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ order.paymentMessage }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table v-else-if="!order.cancelled" class="ak-table ak-table--compact ak-panel__table">
                            <tbody class="ak-table-body">
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ $t('Betaling openstaande') }}
                                    </td>
                                </tr>
                                <tr v-if="ogm" class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ ogm.ogm }}
                                    </td>
                                </tr>
                                <tr v-if="order.paymentMessage" class="ak-table-row">
                                    <td class="ak-table-column">
                                        {{ order.paymentMessage }}
                                    </td>
                                </tr>
                                <tr class="ak-table-row">
                                    <td class="ak-table-column">
                                        <ak-button @click="markAsPaid">
                                            {{ $t('Markeren als betaald') }}
                                        </ak-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="order.isPaid && ! order.cancelled" class="ak-panel ak-panel--no-padding  m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Factuur Exact Online') }}
                            </div>
                        </div>
                        <table class="ak-table ak-table--compact ak-panel__table">
                            <tbody class="ak-table-body">
                                <tr class="ak-table-row">
                                    <td v-if="exactOrder" class="ak-table-column">
                                        <i v-if="exactOrder.status === 3" style="color:green;" class="fa fa-check"></i>
                                        <i v-else class="fa fa-warning"></i>

                                        {{ exactOrder.statusTitle }}
                                    </td>
                                    <td v-else class="ak-table-column">
                                        <ak-button @click="createExactOrder">
                                            {{ $t('Factuur aanmaken in Exact Online') }}
                                        </ak-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                  <div v-if="order.isPaid" class="ak-panel ak-panel--no-padding  m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Exact Online historiek') }}
                            </div>
                        </div>
                        <table class="ak-table ak-table--compact ak-panel__table">
                            <tbody class="ak-table-body">
                                <tr class="ak-table-row">
                                    <td  class="ak-table-column">
                                      todo
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="ak-panel ak-panel--no-padding  m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Factuuradres') }}
                            </div>
                            <a href="#" class="m-l-auto" @click.prevent="openAddressForm">
                                <i class="fa fa-lg fa-edit"></i>
                            </a>
                        </div>
                        <div class="ak-panel__body ak-panel__body--small reading">
                            <p>
                                <strong>{{ order.invoiceFirstName }}  {{ order.invoiceSurnames }}</strong><br>
                                <strong v-if="order.invoiceCompanyName"> {{order.invoiceCompanyName }} </strong>
                                <span v-if="order.invoiceVat"> {{ order.invoiceVat }}</span>
                            </p>
                            <p v-if="order.invoiceStreetAddress || order.invoiceStreetNumber || order.invoiceBoxNumber || order.invoicePostalCode || order.invoiceCity || order.invoiceCountryIso">
                                {{ order.invoiceStreetAddress }} {{order.invoiceStreetNumber }} {{order.invoiceBoxNumber }}<br>
                                {{ order.invoicePostalCode }} {{ order.invoiceCity }} {{order.invoiceCountryIso }}
                            </p>
                            <p>
                                {{ order.phone }}<br>
                                <a :href="'mailto:'+order.email">{{ order.email }}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <router-view
            name="childview"
            @orderSaved="orderSaved"
        />
    </div>
</template>

<script>
export default {
    name: 'OrderOverview',
    data() {
        return {
            order: null,
            exactOrder: null,
            exactOrderPartial: null,
            partialCancellationLines: [],
            ogm: null,
            cart: null,
            cartItemsPickup: null,
            digitalItems: null,
            catalogueOrders: null,
            dellOrder: null,
            hpOrder: null,
            inspector: null,
            receipt: null,
            loading: false,
        }
    },
    methods: {
        async getOrder() {
            this.loading = true;
            const result = await this.$get('/order-overview/' + this.$route.params.orderCode);
            this.loading = false;

            if (result.success) {
                this.order = result.data.order;
                this.exactOrder = result.data.exactOrder;
                this.exactOrderPartial = result.data.exactOrderPartial;
                this.partialCancellationLines = result.data.partialCancellationLines || [];
                this.ogm = result.data.ogm;
                this.cart = result.data.cart;
                this.cartItemsPickup = result.data.cartItemsPickup;
                this.digitalItems = result.data.digitalItems;
                this.catalogueOrders = result.data.catalogueOrders;
                this.dellOrder = result.data.dellOrder;
                this.hpOrder = result.data.hpOrder;
                this.receipt = result.data.receipt;
                this.inspector = result.data.inspector;
            }
        },
        backToOrders() {
            this.$router.push({name: 'grid', params:{bundle: 'cart', gridDefinition: 'grid'}});
        },
        markAsPaid() {
            this.$router.push({name: 'order-overview-form', params:{bundle: 'order', orderCode: this.cart.code, definition: 'payment-form', objectId: this.order.hashId}});
        },
        openCommentsForm() {
            this.$router.push({name: 'order-overview-form', params:{bundle: 'order', orderCode: this.cart.code, definition: 'comments-form', objectId: this.order.hashId}});
        },
        openAddressForm() {
            this.$router.push({name: 'order-overview-form', params:{bundle: 'order', orderCode: this.cart.code, definition: 'address-form', objectId: this.order.hashId}});
        },
        openShippingForm() {
            this.$router.push({name: 'order-overview-form', params:{bundle: 'order', orderCode: this.cart.code, definition: 'shipping-form', objectId: this.order.hashId}});
        },
        openPickupForm(item) {
            this.$router.push({name: 'order-overview-form', params:{bundle: 'cart-item-pickup', orderCode: this.cart.code, definition: 'delivered-form', objectId: item.pickup.hashId}});
        },
        openPartialCancelForm() {
            this.$router.push({name: 'order-overview-form', params:{bundle: 'order', orderCode: this.cart.code, definition: 'cancel-form', objectId: this.order.hashId}});
        },
        openDeliveryForm(item) {
            this.$router.push({name: 'order-overview-form', params:{bundle: 'cart-item', orderCode: this.cart.code, definition: 'delivery-form', objectId: item.hashId}});
        },
        orderSaved() {
            this.getOrder();
            this.$router.push({ name: 'order-overview'});
        },
        async createExactOrder () {
            this.loading = true;
            const result = await this.$get('/order-create-exact/' + this.order.hashId);
            this.loading = false;

            if (result.success) {
                this.getOrder();
                this.$router.push({ name: 'order-overview'});
            }
        },
        async cancelOrder() {
            this.loading = true;
            const result = await this.$get('/order-cancel/' + this.order.hashId);
            this.loading = false;

            if (result.success) {
                this.getOrder();
                this.$router.push({ name: 'order-overview'});
            }
        },
        // Match receipt row to partial-cancel line by shoppable product id.
        // We keep this in one method so template logic stays readable.
        getPartialCancellationLine(receiptLine) {
            if (!receiptLine || !receiptLine.shoppable || !receiptLine.shoppable.id) {
                return null;
            }

            const productId = Number(receiptLine.shoppable.id);
            if (!productId) {
                return null;
            }

            return this.partialCancellationLines.find(line => Number(line.productId) === productId) || null;
        },
        // Resolve product label for history entries based on current receipt data.
        // Fallback is "#<id>" so history remains readable even if product data changed.
        getProductTitleById(productId) {
            const id = Number(productId);
            const receiptItems = this.getReceiptItemsArray();
            const receiptItem = receiptItems.find(item => (
                item.shoppable &&
                Number(item.shoppable.id) === id
            ));

            if (!receiptItem) {
                return `#${id}`;
            }

            return receiptItem.shoppable.title || receiptItem.title || `#${id}`;
        },
        // API can return receipt.items as array or object; normalize once.
        getReceiptItemsArray() {
            const items = this.receipt && this.receipt.items ? this.receipt.items : [];

            if (Array.isArray(items)) {
                return items;
            }

            if (items && typeof items === 'object') {
                return Object.values(items);
            }

            return [];
        }
    },
    computed: {
        // Show newest partial-cancel events first in history.
        partialCancellationLinesSorted() {
            return [...this.partialCancellationLines].sort((a, b) => {
                const dateA = new Date(a.createdAt || a.updatedAt || 0).getTime();
                const dateB = new Date(b.createdAt || b.updatedAt || 0).getTime();

                return dateB - dateA;
            });
        }
    },
    created() {
        this.getOrder();
    }
}
</script>
